import { NgModule } from 'ng-metadata/core';
import {PrimoExploreService} from './primoExplore.service';
const uiRouter  = require('angular-ui-router') as string;
import {PrimoExploreMain} from './primoExploreMain.directive';
import {LoginIframe} from './loginIframe.directive';
import {PrmSilentLogin} from './silentLogin/silentLogin.directive';
import {SilentLoginService} from './silentLogin/silentLogin.service';
// import {FavoritesModule} from '../favorites/favorites.module';
import {TagsModule} from '../tags/tags.module';
import {PrimolyticsModule} from '../analytics/primolytics.module';
import {IconModule} from '../icon/icon.module';
import {SearchModule} from '../search/search.module';
import {NddModule} from '../nddUtils/ndd.module';
import {InfraMetadata} from '../infra/infra-metadata.module';
import {SecurityModule} from '../security/security-metadata.module';
import {ModelModule} from '../infra/dataStructures/model/model.module';
// import {AtozModule} from '../journals/atoz.module';
import {NewspapersModule} from '../newspapers/newspapers.module';
const ngMaterial = require('angular-material');
const ngMessages = require('angular-messages');
const ngSanitize = require('angular-sanitize');
const ngCookies = require('angular-cookies');
const ngRecaptcha= require('angular-recaptcha');
let scrollbarModule = require('angular-perfect-scrollbar-2');
import configModule from './primoExploreConfig.module';
import securityModule from '../security/security.module';
import {ServicePagesModule} from '../servicesPage/servicePages.module';
import {PrimoExplore} from './primoExplore.directive';
import {SpinnerModule} from '../spinner/spinner.module';
import {SourceRecordModule} from '../sourceRecord/sourceRecord.module';
import {BlankIllModule} from '../blankIll/blankIll.module';
import {PurchaseRequestModule} from '../purchaseRequest/purchaseRequest.module';
import {CitationLinkerModule} from '../citationLinker/citationLinker.module';
import {DepositFormModule} from '../infra/deposit/depositForm.module';
import {DepositsLinkModule} from '../account/depositsLink/depositsLink.module';
import {PersonalizeResultsButtonModule} from '../search/personalization/personalizeResultsButton.module';

import {NgForwardHack} from './ngForwardHack.directive';
import {bundle} from 'ng-forward';
import {BrowseSearchModule} from "../search/browse/browseSearch.module";
import {LoginIframeService} from "./loginIframe.service";
// import {CollectionDiscoveryModule} from "../collectionDiscovery/collectionDiscovery.module";
import {PrmSilentLoginAlertToast} from "./silentLogin/silentLoginAlertToast/silentLoginAlertToast.directive";
import {TimeoutToastService} from "../security/timeoutToast/timeoutToast.service";
import {PrmTimeoutToast} from "../security/timeoutToast/timeoutToast.directive";
import * as ocLazyLoad from 'oclazyload';
import {PrmAlertBar} from "../infra/widgets/alerts/alertBar.directive";
import {JournalsService} from "../journals/journals.service";
import {DatabasesService} from "../journals/databases.service";
import {PrmSaveToFavoritesButton} from "../favorites/saveToFavoritesButton/saveToFavoritesButton.directive";
import {FavoritesService} from "../favorites/favorites.service";
import {SearchHistoryService} from "../favorites/searchHistory/searchHistory.service";
import {SavedQueriesService} from "../favorites/savedQueries/savedQueries.service";
import {CollectionDiscoveryService} from "../collectionDiscovery/collectionDiscovery.service";
import {PrmRecordCollectionPaths} from "../collectionDiscovery/recordCollectionPaths/recordCollectionPaths.directive";
import {PrmCollectionNavigationBreadcrumbsItem} from "../collectionDiscovery/collectionNavigationBreadcrumbs/collectionNavigationBreadcrumbsItem/collectionNavigationBreadcrumbsItem.directive";
import {PrmCollectionNavigationBreadcrumbs} from "../collectionDiscovery/collectionNavigationBreadcrumbs/collectionNavigationBreadcrumbs.directive";
import {FullViewService} from '../search/fullView/fullView.service';
import {FullViewLinksService} from "../search/fullView/links/serviceLinks.service";
import {QuickLink} from "../search/quickLink/quickLink.service";
import {LocationService} from "../search/fullView/getit/opac/locations/location/location.service";
import stickyModule from '../infra/sticky';
import {PrmSearchResultThumbnailContainer} from "../search/searchResult/searchResultThumbnail/searchResultThumbnailContainer.directive";
import {FullViewModuleLoaderService} from "../search/fullView/fullViewModuleLoader.service";
import {OpacModule} from '../search/fullView/getit/opac/opac.module'
import {PrmBackToSearchResultsButton} from '../search/fullView/backToSearchResultsButton/backToSearchResultsButton.directive';
import {PrimoExploreFooter} from './primoExploreFooter.directive';
import {PrimoIcpLicenseFooter} from './footers/icpLicenseFooter.directive';
import {ChaptersAndReviewsModule} from "../search/chaptersAndReviews/chaptersAndReviews.module";
import {CMIntegrationService} from '../cm_integration.service';
import {TranslationService} from "../translate/translation.service";
import { OrganizationsService } from '../journals/organizations/organizations.service';
import { PrimoExploreFooterService } from './primoExploreFooter.service';
import {PagesTitlesModule} from "../infra/accessibility/pagesTitles.module";
import {ReportProblemModule} from "../reportProblem/reportProblem.module";
import { PrmFavoritesWarningMessage } from '../favorites/favoritesWarningMessage/favoritesWarningMessage.directive';
import { FavoritesWarningMessageService } from '../favorites/favoritesWarningMessage/favoritesWarningMessage.service';
import { PrmBarcodeSearch } from '../search/searchBar/barcodeSearch/barcodeSearch.directive';
import { BarcodeSearchService } from '../search/searchBar/barcodeSearch/barcodeSearch.service';
import {DigitalPdfStartService} from '../digitalPdfStart.service';
import {PrmPopupMessage} from "../security/popupMessage/popupMessage.directive";
import { PopupMessageService } from '../security/popupMessage/popupMessage.service';
import { PersonEntityPageModule } from '../search/fullView/personEntityPage/personEntityPage.module';
import { PrmCitationTrailsExpandButton } from '../search/citationTrails/citationTrailsExpandButton.directive';
import { CitationTrailsExpandButtonService } from '../search/citationTrails/citationTrailsExpandButton.service';
import {DigitalEpubStartService} from '../digitalEpubStart.service';
import { PrmResearchAssistant } from '../researchAssistant/researchAssistant.directive';
import { ResearchAssistantService } from '../researchAssistant/researchAssistant.service';
import { AuthoritySearchModule } from '../search/authority/authoritySearch.module';
import {OffsetLimitNotificationDirective} from "../infra/widgets/alerts/offset-limit-notification.directive";

@NgModule({
    declarations: [
        PrimoExplore,
        PrimoExploreMain,
        LoginIframe,
        PrmSilentLogin,
        PrmSilentLoginAlertToast,
        PrmTimeoutToast,
        PrmAlertBar,
        PrmSaveToFavoritesButton,
        PrmRecordCollectionPaths,
        PrmCollectionNavigationBreadcrumbs,
        PrmCollectionNavigationBreadcrumbsItem,
        PrmSearchResultThumbnailContainer,
        PrmBackToSearchResultsButton,
        PrimoExploreFooter,
        PrmFavoritesWarningMessage,
        PrmBarcodeSearch,
        PrimoIcpLicenseFooter,
        PrmPopupMessage,
        PrmCitationTrailsExpandButton,
        PrmResearchAssistant,
        OffsetLimitNotificationDirective
    ],
    providers: [
        FullViewModuleLoaderService,
        PrimoExploreService,
        LoginIframeService,
        SilentLoginService,
        TimeoutToastService,
        JournalsService,
        DatabasesService,
        FavoritesService,
        SearchHistoryService,
        SavedQueriesService,
        CollectionDiscoveryService,
        FullViewService,
        QuickLink,
        PrimoExploreFooterService,
        FullViewLinksService,
        LocationService,
        CMIntegrationService,
        TranslationService,
        OrganizationsService,
        FavoritesWarningMessageService,
        BarcodeSearchService,
        DigitalPdfStartService,
        PopupMessageService,
        CitationTrailsExpandButtonService,
        DigitalEpubStartService,
        ResearchAssistantService
    ],
    imports:[
        'primo-explore.infra',
        ocLazyLoad,
        BrowseSearchModule,
        AuthoritySearchModule,
        ChaptersAndReviewsModule,
        IconModule,
        InfraMetadata,
        ModelModule,
        NddModule,
        PrimolyticsModule,
        SearchModule,
        SecurityModule,
        ngMaterial,
        ngMessages,
        ngSanitize,
        ngCookies,
        ngRecaptcha,
        uiRouter,
        configModule.name,
        securityModule.name,
        scrollbarModule,
        SpinnerModule,
        BlankIllModule,
        PurchaseRequestModule,
        ReportProblemModule,
        SourceRecordModule,
        bundle('primo-explore.ngForwardHack',NgForwardHack).name,
        CitationLinkerModule,
        TagsModule,
        DepositFormModule,
        DepositsLinkModule,
        PersonalizeResultsButtonModule,
        NewspapersModule,
        stickyModule.name,
        OpacModule,
        PagesTitlesModule,
        PersonEntityPageModule
    ]
})
export class PrimoExploreModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/components/primoExplore/primoExploreModule.ts